import React from 'react';

const LockIcon = ({ locked }) =>
  locked ? (
    // Closed lock — filled body so it reads as “secured”
    <svg
      className="variables-panel__lock-icon"
      viewBox="0 0 16 16"
      width="14"
      height="14"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M5 7.25V5.1a3 3 0 0 1 6 0v2.15"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <rect x="3.25" y="7.25" width="9.5" height="6.5" rx="1.75" fill="currentColor" />
      <circle cx="8" cy="10.4" r="1" fill="var(--vp-bg, #14181e)" />
    </svg>
  ) : (
    // Open lock — shackle twisted open (classic unlocked padlock)
    <svg
      className="variables-panel__lock-icon"
      viewBox="0 0 16 16"
      width="14"
      height="14"
      aria-hidden="true"
      focusable="false"
    >
      <g transform="rotate(-48 5.4 7.4)">
        <path
          d="M5.4 7.4V4.35a2.65 2.65 0 0 1 5.3 0"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <rect
        x="3.25"
        y="7.25"
        width="9.5"
        height="6.5"
        rx="1.75"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle cx="8" cy="10.4" r="0.9" fill="currentColor" />
    </svg>
  );

export default LockIcon;
